import React, { useState, useContext, useEffect } from "react";
import {
  // List,
  Search,
  // DollarSign,
  Calendar,
  ChevronsLeft,
  CreditCard,
  Monitor,
  FileText
} from "react-feather";
import { Link, useLocation, useHistory } from "react-router-dom";
import { useIntl } from "react-intl";
import logo from "../../../../assets/images/buscar-logo-light.png";
import smallLogo from "../../../../assets/images/buscar-logo-square.png";
import terrasLogo from "../../../../assets/images/terras-logo-light.png";
import UserContext from "./../../../../context/UserContext";
import { formatBalance } from "./../../../../utils/format";
import { trackPageView } from "./../../../../utils/analytics";
import { hasAccessToDashboard } from "./../../../../api";
import { useAmbient } from '../../../../hooks/ambient';
import "./styles.scss";

const Navigation = () => {
  const [open, setOpen] = useState(false);
  const [hasDashboardAccess, setHasDashboardAccess] = useState(false);
  const location = useLocation();
  const { formatMessage } = useIntl();
  const { ambient, isEnterpriseEnv } = useAmbient();

  const userData = useContext(UserContext);
  const userBalance = userData && userData.balance;

  const history = useHistory();

  useEffect(() => {
    const hasAccessStorage = localStorage.getItem('@BusCAR/dashboard-access');

    if (hasAccessStorage === 'false') {
      return () => { };
    }

    if (hasAccessStorage === 'true') {
      setHasDashboardAccess(true);
      return () => { };
    }

    if (!hasAccessStorage) {
      hasAccessToDashboard()
        .then(({ data }) => {
          if (data.acesso) {
            localStorage.setItem('@BusCAR/dashboard-access', true);
            setHasDashboardAccess(true);
          } else {
            throw Error;
          }
        })
        .catch(() => {
          setHasDashboardAccess(false);
          localStorage.setItem('@BusCAR/dashboard-access', false);
        });
      return () => { };
    }

    return () => { };
  }, [hasDashboardAccess])

  const onLogout = () => {
    trackPageView("/logout");
    localStorage.removeItem("access_token");
    localStorage.removeItem("@BusCAR/dashboard-access");
    localStorage.removeItem("@BusCAR:ambient");
    history.push("/login");
  };

  return (
    <section id="navigation" className={open ? "open" : ""}>
      <ChevronsLeft
        className="collapse-button"
        onClick={() => setOpen(!open)}
        size={32}
      />
      <div className="navigation-brand">
        <a href="/">
          <img className="large-logo" src={logo} alt="BusCAR logo" />
        </a>
        <a href="/">
          <img className="small-logo" src={smallLogo} alt="BusCAR logo" />
        </a>
      </div>
      <ul className="page-links">
        <li>
          <Link
            to="/new-analysis"
            className={location.pathname === "/new-analysis" ? "active" : ""}
          >
            <Search className="page-icon" />{" "}
            {formatMessage({ id: "nova-consulta" })}
          </Link>
        </li>
        <li>
          <Link
            to="/history"
            className={location.pathname === "/history" ? "active" : ""}
          >
            <Calendar className="page-icon" />{" "}
            {formatMessage({ id: "historico" })}
          </Link>
        </li>
        {/* <li>
          <a href="#lists">
            <List className="page-icon" /> Listas
          </a>
        </li> */}
        {!isEnterpriseEnv && (
          <li>
            <Link
              to="/add-funds"
              className={location.pathname === "/add-funds" ? "active" : ""}
            >
              {/* <DollarSign className="page-icon" /> {formatBalance(userBalance)}*/}

              <CreditCard className="page-icon" /> R$ {formatBalance(userBalance)}

            </Link>
          </li>
        )}
        {isEnterpriseEnv && ambient.admin && (
          <li>
            <Link
              to="/company-reports"
              className={location.pathname === "/company-reports" ? "active" : ""}
            >
              <FileText className="page-icon" /> {formatMessage({ id: "relatorios-empresariais" })}

            </Link>
          </li>
        )}
        {hasDashboardAccess && (
          <li>
            <Link
              to="/dashboard"
              className={location.pathname === "/dashboard" ? "active" : ""}
            >
              <Monitor className="page-icon" />{" "}
              Dashboard
            </Link>
          </li>
        )}
      </ul>
      <ul
        className={`auth-item language-options ${open ? "clear-media-query" : ""
          }`}
      >
        <li>
          <a
            href="#/"
            data-testid="-br"
            onClick={() => userData.storeLang("pt-BR")}
          >
            <span className="flag-icon flag-icon-br"></span>
          </a>
        </li>
        <li>
          <a
            href="#/"
            data-testid="-us"
            onClick={() => userData.storeLang("en-US")}
          >
            <span className="flag-icon flag-icon-us"></span>
          </a>
        </li>
      </ul>

      <div className="navigation-footer">
        <ul>
          <li>
            <Link to="/about">{formatMessage({ id: "sobre" })}</Link>
          </li>
          <li>
            <Link to="/manual">Manual</Link>
          </li>
          <li>
            <Link to="/terms-of-use">
              {formatMessage({ id: "termos-uso" })}
            </Link>
          </li>
          <li>
            <Link to="/privacy-policy">
              {formatMessage({ id: "politica-privacidade" })}
            </Link>
          </li>
          <li>
            <Link to="/faq">
              {formatMessage({ id: "perguntas-frequentes" })}
            </Link>
          </li>
          <li>
            <Link to="/contact">{formatMessage({ id: "contato" })}</Link>
          </li>
          {/* TODO: Remove once user section has been implemented */}
          <li>
            <button className="link-button" onClick={onLogout}>
              {formatMessage({ id: "sair" })}
            </button>
          </li>
        </ul>
        <div className="powered-by">
          <img src={terrasLogo} alt="Terras logo" />
        </div>
      </div>
    </section>
  );
};

export default Navigation;
